import { sub } from 'date-fns';
import { TranslationObject } from './types';
import { createLesson } from '@/services/eventService';

export const en = {
  translation: {
    accounts: {
      coachAccount: "Coach Account",
      studentAccount: "Student Account",
      parentAccount: "Family Account",
      schoolAccount: "School Account",
      schoolAdminAccount: "School Account",
      schoolTeacherAccount: "Teacher Account"
    },
    profile:{
      title: "My Account",
      subTitle: "Manage your profile information",
      firstname: "Firstname",
      lastname: "Lastname",
      email: "Email",
      save: "Save Changes",
      connected: "Connected",
      accountType: "Account Type",
      companyName: "School / Company Name",
      teacherConnectedToSchool: "School",
      teacherConnectedToCoach: "Coach",
      Tabs:{
        profile: "Profile",
        billing: "Billing",
        subscritpion: "My Subscription",
        security: "Security",
        sessions:  "Sessions",
        referral: "Referral",
        mySchool: "My School",
        logout: "Logout",
        notifications: "Notifications",
        invitation: "Invitation",
        join: "Join",
        help: "Help",
        support: "Support",
      },
      security_subTitle: "Manage your security settings",
      twoFactorAuth: "Two-Factor Authentication",
      enable2FA: "Enable 2FA",
      TwoFA_explication: "Enable two-factor authentication for enhanced security.",
      noChangePassword: "Password changes are not available when signed in with Apple or Google accounts",
      subscription_subTitle: "Manage your subscription and payment method",
      currentPlan: "Current Plan",
      Trial:  "Trial",
      active: "Active",
      free: "Free",
      your_trial_ends: "Your trial ends on",
      paymentMethods: "Payment Methods",
      billingHistory: "Billing History",
      your_next_billing_date: "Your next billing date is",
      perMonth: "/month",
      changePlan: "Change Plan",
      noActiveSubscription: "No active subscription.",
      noActiveSubscriptionExplication: "You can subscribe to a plan to access premium features",
      willBeCancel: "cancelled",
      subscribeNow: "Subscribe Now",
      expires: "Expires",
      edit: "Edit",
      delete: "Delete",
      premiumPlan: "Premium Plan",
      fullAccess: "Full Access",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      changePassword: "Change Password",
      cancelSubscription: "Cancel Subscription",
      confirmCancel: "Are you sure you want to cancel your subscription to ThePoppyApp ?",
      yesConfirm: "Yes, i confirm !",
      validUntil: "Your subscription will still be valid until",
      cancelSuccess: "Subscription cancelled",
      cancelSuccessDesc: "Your subscription has been cancelled and will end on",
      cancelError: "An error has occurred. Please try again in a few moments",
      discount: "Discount",
      codePromo: "You are currently receiving a {{percent_off}}% discount on your subscription",
      noCancel: "Do not cancel",
      noCancelDesc: "You recently requested to cancel your ThePoppyApp subscription. Would you like to stop canceling and keep your subscription?",
      noCancelSuccess: "Subscription retablished",
      noCancelSuccessDesc: "Your subscription is active",
      changeCard: "Change payment method",
      changeCardDesc: "This new payment method will be used for your future monthly payments to pay for your ThePoppyApp subscription.",
      updatePaymentMethod: "Update Payment Method",
      manageProfileAvatar: "Manage your Profile Avatar",
      uploadAvatar: "Upload Avatar",
      changeAvatar: "Change Avatar",
      addCoupon: "Enter a promo code to be applied on your next invoice",
      coupon: "Coupon",
      changeHasBeenApplied: "The change has been applied to your account",
      updateFailed: "Update failed, please try again later",
      pleaseRetry: "Please try again",
      paymentMethodSaved: "Your payment method has been updated successfully",
      sessionLoggedOut: "Session logged out",
      sessionLoggedOutDesc: "The session has been logged out successfully",
      newPasswordNotMatch: "New passwords do not match",
      passwordUpdated: "Password updated",
      yourPasswordChanged: "Your password has been changed successfully",
      help: {
        subtitle: "How can we help you ?",
        checklistTitle: "Steps to get started",
        createCategory: "How to create a category ?",
        createStudent: "How to create a student ?",
        createEvent: "How to create an event ?",
        restart: "Restart the Tutorial ?",
      }
    },
    deleteAccount: {
      title: "Delete your account",
      description: "Are you sure you want to delete your account? This action cannot be undone. You will receive an email to confirm your request.",
      lastConfirmation: "Please confirm that you want to proceed with this irreversible action.",
      confirm: "Request account deletion",
      requestSent: "Request sent",
      emailConfirmation: "Please check your email to confirm your account deletion.",
      deleteMyAccount: "Delete my account",
      confirmDeleteTitle: "Confirm account deletion",
      confirmDeleteDesc: "Confirming the deletion of your account will result in the permanent deletion of your account and all associated data. This action is irreversible.",
      confirmDelete: "Confirm account deletion",
      deleteAccountWarning: "Once you delete your account, there is no going back. Please be certain.",
      confirmedDeleteTitle: "Account deletion confirmed",
      deleteSuccessMessage: "Your account has been successfully deleted. We're sorry to see you go. If you change your mind, feel free to create a new account and join us again!"
    },
    common: {
      ok: "OK",
      apply: "Apply",
      hide: "Hide",
      send: "Send",
      failedNetwork: "Unable to request. Check your internet connection",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      reset: "Reset",
      timezone: "Timezone",
      actions: "Actions",
      allRightsReserved: "All rights reserved",
      selectTimezone: "Select a timezone",
      sending: "Sending...",
      processing: "Processing...",
      deleting: "Deleting...",
      username: "Choose a login ID",
      firstName: "Firstname",
      lastName: "Lastname",
      done: "Done",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      login: "Log in",
      register: "Sign up",
      name: "Full Name",
      loading: "Loading...",
      forgotPassword: "Forgot password?",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      search: "Search",
      filters: "Filters",
      all: "All",
      add: "Add",
      remove: "Remove",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      back: "Back",
      next: "Next",
      continue: "Continue",
      create: "Create",
      update: "Update",
      view: "View",
      preview: "Preview",
      download: "Download",
      downloadApp: "Download App",
      backToLogin: "Back to login",
      learnMore: "Learn more",
      getStarted: "Get Started",
      success: "Success!",
      error: "Error!",
      offlineMessage: "You are currently offline. Some features may not be available.",
      onlineMessage: "Your connection has been restored.",
      dismiss: "Dismiss",
      country: "Country",
      addNew: "Add New",
      close: "Close",
      save_change: "Save changes",
      sendAt: "Send at",
      to: "to",
      newEventAdded: "New event added",
      with: "with",
    },
    
    nav: {
      home: "Home",
      agenda: "Schedule",
      students: "Students",
      teachers: "Teachers",
      invoices: "Invoices",
      messagerie: "Messages",
      reports: "Reports",
      settings: "Settings",
      profile: "Profile",
      account: "Account",
      myAccount: "My Account",
      logout: "Logout",
      help: "Help",
      support: "Support",
      feedback: "Feedback",
      pricing: "Pricing",
      features: "Features",
      contact: "Contact",
      about: "About",
      legal: "Legal",
      terms: "Terms",
      privacy: "Privacy",
      faq: "FAQ",
      documentation: "Documentation"
    },
    
    login: {
      title: "Welcome back",
      username: "Username (Login ID)",
      usernamePlaceholder: "Enter your username",
      password: "Password",
      addAnotherAccount: "Add another account",
      addAnotherAccountDesc: "Sign in to another ThePoppyApp account to switch between them easily",
      switchAccount: "Switch account",
      loginSuccess: "Login successful",
      loginFailed: "Login failed",
      logout: "Logout",
      loggout: "Logout successful",
      loggoutFailed: "Logout failed",
      loggoutSuccessDesc: "You have been successfully logged out",
      connectedWithGoogle: "Connected with your Google account",
      pleaseTryAgain: "Please check your credentials and try again",
      subtitle: "Enter your credentials to access your account",
      orContinueWith: "Or continue with",
      noAccount: "Don't have an account?",
      createAccount: "Create an account",
      continueWithApple: "Continue with Apple",
      continueWithGoogle: "Continue with Google",
      twoFaTitle: "Two-Factor Authentication",
      twoFaSubtitle: "Enter the code from your authenticator app to continue",
      verif: "Verify",
      twoFaDescription: "Protect your account with a 6-digit code generated by your authentication app (Google Authenticator, Authy, 1Password…).",
      activate2FABtn: "Activate",
      desactivate2FABtn: "Deactivate",
      twoFAEnabled: "Enabled",
      twoFADisabled: "Disabled",
      addAccountTOAuthApp: "Add this account to your authentication app",
      ScanQrCode: "Scan the QR code with your authentication app",
      secretKey: "Secret Key",
      account: "Account",
      issuer: "Issuer",
      iAddedAccount: "I have added the account to my authentication app",
      enterCode: "Enter the 6-digit code from your authentication app",
      accountProtected: "Your account is now protected with two-factor authentication",
      enableTwoFa: "Enable 2FA",
      seeAgainKey: "See the key again",
      atNextCOnnection: "You will be asked for this code at your next connection",
      saveRecoveryCodes: "Save these recovery codes in a safe place. They will not be shown again.",
      openMyAuthApp: "Open your authentication app and add a new account using the QR code or secret key provided.",
      showQrCode: "Show QR Code",
      done: "Done",
      secureYourAccount: "Secure Your Account",
      secureYouAccountDesc: "Enable two-factor authentication (2FA) to add a 6-digit code to each login. Strongly recommended.",
      deactivateSecureAccount: "Disable two-factor authentication (2FA) for your account. You will no longer be prompted to enter a 6-digit code during logins.",
      enableNow: "Enable Now",
      nextTime: "Later",
      noMorePrompt: "Don't show this again",
    },
    
    register: {
      title: "Create an account",
      coach: "Coach",
      school: "School",
      schoolName: "School's name",
      userInformations: "Information from the manager",
      coachInformations: "Information from the coach",
      connexionInformations: "Login information",
      subtitle: "Fill in your details to get started",
      hasAccount: "Already have an account?",
      login: "Log in",
      terms: "By signing up, you agree to our Terms of Service and Privacy Policy",
      passwordMismatch: "Passwords do not match",
      joinToday: "Join Today",
      orSignUpWith: "Or sign up with",
      continueWithApple: "Continue with Apple",
      continueWithGoogle: "Continue with Google",
      tokenValidationFailed: "Token validation failed",
      tokenMissing: "Token is missing",
      invalidToken: "Invalid token",
      referralRegister: "You are signing up through a referral link",
      student: {
        title: "Student Registration",
        subtitle: "Fill in your details to join the school",
        welcome: "You are invited to join the school: {{schoolName}}",
        join_now: "Join Now",
      },
      teacher: {
        title: "Teacher Registration",
        subtitle: "Fill in your details to join the school",
        welcome: "You are invited to join the school: {{schoolName}}",
        join_now: "Join Now",
      },
      parent: {
        title: "Parent Registration",
        subtitle: "Fill in your details to join the school",
        welcome: "You are invited to join the school: {{schoolName}}",
        join_now: "Join Now",
      },
      accountCreated: "Account created successfully",
      success: "Success!",
      registrationFailed: "Please choose another username to continue.",
      joinCommunity: "Join our coaching community",
      createYourAccount: "Create your account and start enjoying these benefits",
      steps: {
        benefits: {
          "1": "Smart scheduling that saves you time",
          "2": "Client management and progress tracking",
          "3": "Secure payment processing",
          "4": "Mobile apps for iOS and Android",
          "5": "Data insights and business analytics",
          "6": "24/7 customer support"
        }
      }
    },
    
    forgotPassword: {
      title: "Forgot Password",
      username: "Username (your Login ID)",
      subtitle: "Enter your username and we'll send you a link to reset your password",
      resetLink: "Send Reset Link",
      resetButton: "Reset Password",
      rememberPassword: "Remember your password?",
      login: "Log in",
      checkEmail: "Check your email",
      checkEmailDesc: "If an account exists for {email}, we've sent a password reset link.",
      emailSent: "We've sent a password reset link to your email address.",
      sidebarTitle: "Get back to your coaching platform",
      sidebarText: "After resetting your password, you'll have full access to all of your coaching tools, client data and scheduling features.",
      errorTitle: "Error",
      errorGeneric: "An error occurred. Please try again later.",
      successTitle: "Email Sent",
      successDescription: "Check your inbox for the password reset link.",
      error: "Please try with another username",
      enterPassword: "Please enter a new password and confirm it for your account",
      passwordsDoNotMatch: "Passwords do not match",
      passwordTooShort: "Password too short",
    },
    
    home: {
      download: {
        title: "Download our app and manage your coaching on the go",
        subtitle: "Get access to all features from your mobile device",
        ios: "Download for iOS",
        android: "Download for Android",
        simple: "Easy Scheduling",
        simpleDesc: "Easily organize your sessions with students",
        realTime: "Synchronisation",
        realTimeDesc: "Lessons auto synchronised with students planning",
        securePayment: "Secure Payments",
        securePaymentDesc: "Get paid directly through the app",
        alwaysOnline: "Always Accessible",
        alwaysOnlineDesc: "Work from anywhere, anytime",
      }
    },

    hero: {
      title: "Elevate Your Coaching Business",
      subtitle: "The all-in-one platform to manage your coaching business with performance and simplicity",
      cta: "Get Started",
      sessionComplete: "Session completed",
      progressUpdated: "Progress updated",
      newBooking: "New booking",
      bookingTime: "Tuesday at 2PM"
    },
    
    features: {
      title: "Powerful Features For Coaches",
      subtitle: "Everything you need to manage your coaching business in one place",
      smartScheduling: {
        title: "Smart Scheduling",
        description: "Efficiently manage your calendar with automated scheduling tools and reminders"
      },
      studentManagement: {
        title: "Student Management",
        description: "Keep track of all your students' information and progress in one organized system"
      },
      categoriesManagement: {
        title: "Categories Management",
        description: "Organize your sessions by categories to better track your teaching activities"
      },
      onlinePayments: {
        title: "Online Payments",
        description: "Accept payments directly through the platform with secure payment processing"
      },
      studentAccounts: {
        title: "Student Accounts",
        description: "Give your students access to their own portal to view schedules and materials"
      },
      aiSummaries: {
        title: "AI-Powered Summaries",
        description: "Generate automatic session summaries and progress reports using AI technology"
      },
      schoolAccounts: {
        title: "School Accounts",
        description: "Create a structure bringing together several coaches, manage your team and run your establishment"
      },
      parentAccounts: {
        title: "Families Accounts",
        description: "Give group access to family members to view schedules"
      },
       automaticInvoices: {
        title: "Automated billing",
        description: "Automatically generate invoices on your schedule, with integrated payment and automatic reminders"
      }
    },
    
    pricing: {
      title: "Simple, Transparent Pricing",
      subtitle: "Choose the plan that works best for your coaching business",
      monthly: "Monthly",
      yearly: "Yearly",
      cta: "Get Started",
      popular: "Most Popular",
      login_required: "Login Required",
      login_to_continue: "Please login or create an account to continue with your subscription",
      starter: {
        title: "Single Coach",
        price: "249",
        description: "Perfect for individual coaches just getting started",
        features: [
          "Basic scheduling",
          "Email notifications",
          "Payment tracking",
          "Mobile app access"
        ]
      },
      professional: {
        title: "School",
        price: "449",
        description: "Great for established coaches with a growing client base",
        features: [
          "Advanced scheduling",
          "SMS notifications",
          "Online payments",
          "Custom branding",
          "Student portal access",
          "Priority support"
        ]
      },
      premium: {
        title: "Premium",
        price: "49",
        description: "Great for established coaches with a growing client base",
        features: [
          "Advanced scheduling",
          "SMS notifications",
          "Online payments",
          "Custom branding",
          "Student portal access",
          "Priority support"
        ]
      },
      elite: {
        title: "Elite",
        price: "99",
        description: "For coaching businesses with multiple coaches and high volume",
        features: [
          "Unlimited students",
          "Multiple coach accounts",
          "Advanced analytics",
          "White-label solution",
          "API access",
          "Dedicated account manager",
          "Custom integrations"
        ]
      }
    },
    
    agenda: {
      title: "Schedule",
      today: "Today",
      month: "Month",
      week: "Week",
      view:"view",
      day: "Day",
      list: "List",
      edit: "Edit",
      teacher: "Teacher",
      selectTeacher: "Select Teacher",
      createInvoice: "Create Invoice",
      createStudentInvoice: "Create Student Invoice",
      newEvent: "New Event",
      editEvent: "Edit Event",
      deleteEvent: "Delete",
      eventName: "Event Name",
      startDate: "Start Date",
      endDate: "End Date",
      location: "Location",
      currency: "Currency",
      description: "Description",
      repeat: "Repeat",
      reminder: "Reminder",
      students: "Students",
      student: "Student",
      noEvents: "No events found",
      noEventsDescription: "There are no events scheduled for this period",
      charges: "Charges",
      extraCharges: "Extra charges",
      addYourFirst: "Add your first event",
      upcoming: "Upcoming Events",
      past: "Past",
      allDay: "All day",
      allDayWeek: "All day",
      frequency: "Frequency",
      until: "Until",
      once: "Once",
      daily: "Daily",
      weekly: "Weekly",
      biweekly: "Biweekly",
      quarterly: "Quarterly",
      monthly: "Monthly",
      yearly: "Yearly",
      category: "Category",
      categories: "Categories",
      addCategory: "Add Category",
      addLocation: "Add Location",
      categoryName: "Category Name",
      categoryColor: "Category Color",
      locationName: "Location Name",
      locationAddress: "Location Address",
      notes: "Notes",
      status: "Status",
      confirmed: "Confirmed",
      tentative: "Tentative",
      cancelled: "Cancelled",
      filter: "Filter",
      clearFilters: "Clear Filters",
      search: "Search Events",
      export: "Export",
      import: "Import",
      print: "Print",
      save: "Save Event",
      cancel: "Cancel",
      delete: "Delete Event",
      confirmDeletion: "Confirm Deletion",
      confirmDelete: "Are you sure you want to delete this event?",
      deleteAllRecurrence: "Delete All Recurrences",
      eventSaved: "Event saved successfully",
      eventDeleted: "Event deleted successfully",
      eventCreated: "Event created successfully",
      calendar: "Calendar",
      timeline: "Timeline",
      newLesson: "Create new",
      scheduleLessonTitle: "Schedule",
      scheduleLessonDesc: "Fill in the details to schedule a new lesson with your students",
      showFromToday: "Show from today",
      showFullWeek: "Show full week",
      showUpcomingYear: "Show upcoming year",
      loadMore: "Load next events",
      viewListYear: "Year List",
      showCurrentWeek: "Show this week",
      currentYear: "Current Year",
      dateRangeHint: "Select a date range",
      selectCategory: "Select a category",
      selectLocation: "Select a location",
      optional: "optional",
      startTime: "Start Time",
      endTime: "End Time",
      date: "Date",
      priceCalculation: "Price calculation",
      duration: "Duration",
      numberOfStudents: "Number of Students",
      createNewLesson: "Create Lesson",
      totalPrice: "Total Price",
      paymentType: "Payment Type",
      createEvent: "Create Event",
      eventType: "Event Type",
      specialEvent: "Event",
      studentAbsence: "Student Day off",
      coachAbsence: "Coach Time off",
      minutes: "Minutes",
      fixedPrice: "Fixed Price",
      hourly_rate: "Hourly Rate",
      pickDate: "Pick a date",
      isRecurring: "This is a recurring event",
      recurrenceEndDate: "Recurrence End Date",
      note: "Note",
      notesPlaceholder: "Add any notes or details about this lesson...",
      createLesson: "Save Lesson",
      addNew: "Add New",
      eventsInView: "events found",
      viewType: "View Type",
      markCompleted: "Mark Completed",
      deleteEvents: "Delete all",
      timeAndDate: "Calendar",
      myAgenda: "Schedule",
      noTeacherFound: "No teacher found",
      actions: "Manage schedule",
      pastEvents: "Past Events",
      futureEvents: "Incoming Events",
      selectAll: "Select All",
      deselectAll: "Delete All",
      markCompletedTitle: "Select events to complete",
      markCompletedDesc: "Mark these events as completed",
      deleteEventsTitle: "Select events to delete",
      deleteEventsDesc: "Select the events you want to delete",
      calendarSettings: "Calendar Settings",
      timezone: "Change Timezone",
      showWeekends: "Show Weekends",
      hideSidebar: "Fullscreen Mode",
      showSidebar: "Quit Fullscreen Mode",
      todaysLessons: "Today",
      currentTime: "Current time",
      timezoneChanged: "Timezone Changed",
      calendarNowUsing: "Calendar is now using",
      weekendsShown: "Weekends Shown",
      weekendsHidden: "Weekends Hidden",
      resetCalendar: "Reset Calendar",
      settings: "Settings",
      selectTimezone: "Select Timezone",
      apply: "Apply",
      noLessonsToday: "No lessons scheduled for today",
      noPastEvents: "No past events",
      noFutureEvents: "No future events",
      noUncompletedPastEvents: "No uncompleted past events",
      noUncompletedFutureEvents: "No uncompleted future events",
      selectStudents: "Select students",
      selectTeachers: "Select teachers",
      teachers: "Teachers",
      searchStudent: "Search",
      noStudentFound: "No student found",
      remove: "Remove",
      manageLessons: "Actions",
      exportLessons: "Export lessons",
      exportDescription: "Export your lessons from the current view in your prefered format",
      printableDocument: "Printable document",
      spreadsheetFormat: "Spreadsheet format",
      developerFriendly: "Developer friendly",
      eventsExportedSuccessfully: "Lessons exported successfully",
      markAsCompleted: "Approve all",
      markEventAsCompleted: "Approve",
      addExtraExpenses: "Extra expenses",
      moreOptions: "More options",
      recurring: "Recurring",
      recurrenceType: "Recurrence Type",
      every7Days: "Every day (Monday to Monday)",
      every14Days: "Every Monday to Friday",
      every30Days: "Every Monday to Saturday",
      everyWeek: "Every Week",
      hourlyRate: "Hourly rate",
      selectEventsToMarkAsCompleted: "Select Events to approve",
      selectEventsToDelete: "Select Events To Delete",
      lessons: "Lessons",
      events: "Events",
      all: "All",
      filterBy: "Filter by",
      noEventsFound: "No events found",
      firstDayOfWeek:"First Day Of Week",
      dayStartTime: "Start time",
      dayEndTime: "End time",
      monday: "Monday",
      sunday: "Sunday",
      eventTextColor: "Text color",
      light: "Light",
      dark: "Dark",
      filters: "Filters",
      filterCategories: "Filter by categories",
      filterStudents: "Filter by students",
      filterLocations: "Filter by locations",
      searchStudents: "Search students",
      activeFilters: "Active filters",
      hidden: "(hidden)",
      exportEvents: "Export schedule",
      exportEventsDescription: "Select a format to export your current view",
      exportNow: "Export now",
      noStudents: "No students found",
      noCategories: "No categories found",
      noLocations: "No locations found",
      viewMonth: "View Month",
      viewYear: "View Year",
      viewWeek: "View Week",
      viewDay: "View Day",
      viewList: "View List",
      newLessonAdded: "Lesson created",
      copy: "Copy",
      copyAll: "Copy all",
      pasteNow: "Paste here",
      copyEvents: "Copy events",
      pasteEvents: "Past Events",
      pasteEventsConfirmation: "Are you sure you want to paste events?",
      targetTimeframe: "Target timeframe",
      sourceTimeframe: "Source timeframe",
      invoiceTypeS: "School Invoice",
      invoiceTypeT: "Teacher Invoice",
      willPaste: "Will paste",
      confirmPaste: "Confirm paste",
      changeViewToPaste: "Change view to paste",
      eventsCopied: "Events copied",
      event: "Event",
      schools: "Schools",
      pasteError: "Error pasting events",
      lessonCreated: "Lesson created",
      adjustDuration: "Adjust duration",
      settingRequired: "No selected student",
      createBySchool: "Created by school",
      eventForOtherCoach: "Owned by another coach",
      eventMultiTeachers: "Multi teachers",
      createNew: {
        title: "Title",
        titlePlaceholder: "Add a title",
        price: "Price",
        extra: "Extra",
        extra_per_student:"Extra per student",
        extraStudentOnly: "The extra will be charge each student and paid each teacher",
        noteInfo: "The details of the extra charges written here will show on the invoice"
      },
      addExtraForm: {
        title: "Manage additional fees",
        subTitle: "Attach your receipts",
        schoolFees: "School fees",
        teacherFees: "Teacher fees",
        description: "Description of additional fees",
        amount: "Amount of additional fees",
        add: "Add additional fees",
        noExtraFees: "Aucun frais supplémentaire ajouté",
        takePhotoOrUpload: "Take a photo or upload a receipt",
        preFilled: "Pre-filled",
        receipt: "Receipt",
      },
      createFirstCategory: "Create your first category",
      createFirstLocation: "Create your first location",
      createFirstStudent: "Create your first student",
      completed: "Completed",
      confirmUnlock: "Confirm unlock",
      unlock: "Please confirm that you want to unlock this lesson",
      unlockButton: "Unlock",
      pleaseSelectDate: "Please select a date",
      pleaseSelectRequiredFields: "Please select required fields",
      endDateCannotBeBeforeStartDate: "End date cannot be before start date",
      pleaseSelectRecurrenceEndDate: "Please select a recurrence end date",
      pleaseTryAgain: "Please try again",
      missingInformation: "Missing information",
      markAsAbsent: "Mark as absent",
      markAsPresent: "Mark as present",
      statut: "Status",
      absent: "Absent",
      present: "Present",
      saveAllRecurrence: "Save all recurrence",
      schoolCategories: "School Categories",
      teacherCategories: "Coach Categories",
      teacherRequired: "Teacher Required",
      categoryRequired: "Category is required",
      studentRequired: "You need to select at leat 1 student",
      validationError: "Required Field",
      pendingSetting: "Set up this course",
      invoiceType: "Invoice type",
      selectTeacherFirst: "Select Teacher Fist",
      newEventAdded:"New Event Added",
      saveAndContinue: "Save and create new",
      privateLesson: "Private",
      Lesson: "Lesson",
      Event: "Event",
      unknownType: "Unknown event type",
      categoryChoosenByTeacher: "Teacher Invoice : the teacher choose the category",
      schoolCategory: "School Category : the school choose the category",
      schoolForCoachCategory: "Teacher invoice: the school can choose the category but the coach can change it",
      searchFilters: "Search student(s)",
      eventNotConfigured: "(Other)",
      clearAll: "Clear All",
      locations: "Locations",
      showCompletedEvents: "Show completed",
      categoryAdded: "Category added",
      addedToCategoriesList: "added to categories list",
      noSelectedCategory: "No selected category",
      selectCategoryFirst: "You must assign a category to this lesson to continue",
      studentOff: {
      title: "Student Day Off",
      description: "Use this form to report your absence. Your coach will be automatically notified.",
      titleLabel: "Absence title",
      titlePlaceholder: "Ex: Sick leave, Travel...",
      startDate: "Start date",
      endDate: "End date",
      chooseDate: "Choose a date",
      oneDayAbsence: "One-day absence",
      dateRange: "From {{start}} to {{end}}",
      noteLabel: "Reason / Notes (optional)",
      notePlaceholder: "Specify the reason for your absence if necessary...",
      cancel: "Cancel",
      reportAbsence: "Report absence",
      sending: "Sending...",
      selectChildren: "Select Members",
      selectedChildren: "selected members",
    },
    invalidDateRange: "Invalid date range",
    absenceReported: "Absence reported",
    absenceSuccessfullyRecorded: "Your absence has been successfully recorded.",
    errorCreatingAbsence: "Failed to create absence",
    error: "Error",
    unknownError: "An error occurred, please try again.",
    alreadyInvoiced: "Already invoiced",
    allInvoiced: "All invoiced",
    pleaseUnlockBeforeMove: "Please unlock before move",
    pleaseUnlockBeforeResize: "Please unlock before resize",
    inProgress: "In progress",
    isCompleted: "Completed",
    hours: "hours",
    },
    
    invoices: {
      title: "Invoices",
      events: "lessons",
      noInvoices: "No Invoices found",
      noPendingBillings: "No pending billings",
      currency: "Currency",
      billingPeriod: "Billing Period",
      search: "Search an invoice",
      billingStudents: "Billing Student",
      billingTeachers: "Billing Teacher",
      createNew: "Create manual invoice",
      pendingBillings: "Pending Billings",
      pendingBillingsDescription: "Select a student to bill",
      pendingValidation: "Completed Courses to Validate",
      pendingValidationDescription: "Unvalidated events to validate before billing",
      pendingValidationBannerTitle: "Completed courses are waiting for validation",
      pendingValidationBannerDescription: "You have {{count}} completed course(s) to validate before you can invoice them.",
      pendingValidationEventSingular: "course to validate",
      pendingValidationEventPlural: "courses to validate",
      validate: "Validate",
      validateSelected: "Validate selection",
      validateAll: "Validate all",
      eventsValidated: "Events validated",
      eventsValidatedDescription: "Selected events have been successfully validated.",
      noPendingValidationEvents: "No events pending validation",
      selectAll: "Select all",
      selectEvent: "Select event",
      results: "result(s)",
      student: "Student",
      teacher: "Teacher",
      studentInvoices: "Invoice students",
      teacherInvoices: "Invoice coaches",
      pendingEvents: "Waiting for billing",
      selectEventsToInvoice: "Select lessons to add to you invoice",
      lastEventDate: "Last Event Date",
      estimatedAmount: "Estimated Amount",
      createInvoice: "Create an invoice",
      parameters: "Student invoice",
      teacherParameters: "Teacher invoice",
      filters: "Filters",
      date: "Date",
      category: "Category",
      duration: "Duration",
      amount: "Amount",
      extraCharges: "Extra Charges",
      invoiceNumber: "Invoice Number",
      invoiceDate: "Invoice Date",
      billingPeriodDateTooltip: "The billing period will be used in the annual billing report",
      dueDate: "Due Date",
      issueDate: "Issue Date",
      notes: "Notes",
      taxes: "Taxes",
      discount: "Discount",
      noDiscount: "No Discount",
      percentageDiscount: "Percentage Discount",
      amountDiscount: "Amount Discount",
      discountScope: "Apply to",
      discountScopeAll: "All lessons and events",
      discountScopeLessons: "Lessons only",
      discountScopeEvents: "Events only",
      summary: "Summary",
      subtotal: "Subtotal",
      tax: "Tax",
      total: "Total",
      newInvoice: "New manual invoice",
      newInvoiceDescription: "Create a student invoice, please choose a student and add items to the invoice with a date, a description and an amount.",
      items: "Items",
      addItem: "Add item",
      description: "Description",
      feeDescriptionPlaceholder: "Fee title",
      addFee: "Add fee",
      noTaxes: "No taxe available",
      additionalFees: "Additional fees",
      feeDescription: "Fee Description",
      create: "Create",
      recurrentDate: "Recurring date",
      addItemsToInvoice: "Add items to your invoice",
      recurrenceFrequency: "Recurrence Frequency",
      recurrenceEndDate: "Recurrence End Date",
      itemValidationError: "Please fill in all item fields",
      noItemsAdded: "No items added yet",
      selectStudent: "Select at least one student",
      pleaseSelectStudent: "Please select a student to continue",
      recurrentInvoice: "Recurrent Invoice",
      recurrentInvoiceDescription: "This invoice will be automatically recreated according to the chosen frequency until the end of the recurrence date",
      noStudentSelected: "No student selected",
      nextInvoiceDate: "Next invoice date",
      pleaseAddItems: "Please add items to your invoice",
      recurrentDateRequired: "Recurrent date is required for recurrent invoices",
      selected: "selected",
      invoiceSent: "Invoice Sent",
      recurringInvoices: "Recurring Invoices",
      invoiceSentDescription: "Invoice Sent Description",
      invoiceNotSent: "Invoice Not Sent",
      invoiceNotSentDescription: "Invoice Not Sent Description",
      notesPlaceholder: "Add Note",
      descriptionPlaceholder: "Item title",
      filterDescription: "Filter Description",
      filterByCategory: "Filter By Category",
      filterByPeriod: "Filter By Period",
      allCategories: "All Categories",
      allTime: "All Time",
      currentMonth: "Current Month",
      currentYear: "Current Year",
      customDateRange: "Custom Date Range",
      dateRange: "Date Range",
      pickDateRange: "Pick Date Range",
      noResultsFound: "No results found",
      deleted: "Deleted",
      send: "Send",
      resend: "Resend",
      sended: "Sent at",
      invoiceWillBeSentWithOverdue: "The invoice will be sent with an \"Overdue\" status",
      noEmailsAvailable: "No emails available for this student",
      createSenderEmail: "Save as the student's default address",
      expenses: "Expenses",
      report: "Report",
      downloading: "Downloading...",
      registeredPaymentMethods: "Others payment methods",
      editInvoice: "Edit invoice",
      noPendingEvents: "No pending events",
      lastInvoiceDate: "Last invoice date",
      recurringValid: "Recurring invoice valid",
      recurringInvalid: "Recurring invoice terminated",
      invoiceUpdated: "Invoice updated",
      invoiceUpdatedDescription: "Invoice updated successfully",
      invoiceCreated: "Invoice created",
      invoiceCreatedDescription: "Invoice created successfully",
      recurrenceStopped: "Recurrence stopped",
      recurrenceStoppedDescription: "The recurring invoice has been successfully stopped.",
      recurringInProgress: "In progress",
      recurringStopped: "Terminated",
      recurringFrequencyList: {
        daily: "Daily",
        weekly: "Weekly",
        biweekly: "Biweekly",
        monthly: "Monthly",
        quarterly: "Quarterly",
        yearly: "Yearly"
      },
      filter:{
        status: "Filter by status",
        type: "Filter by type",
        date: "Filter by date",
        selectDate: "Select Date",
        allStudents: "All Students",
        allTeachers: "All Teachers",
        allStatuses: "All Statuses",
        allTypes: "All Types",
        resetFilters: "Reset filters",
        year: "Year",
        allYears: "All Years",
      },
      type: {
        automatic: "Invoices",
        manual: "Manual invoices",
        shop: "Shop invoices"
      },
      status: {
        paid: "Paid",
        paid_cash: "Paid (cash)",
        paid_card: "Paid (card)",
        pending: "Pending",
        overdue: "Overdue"
      },
      columns: {
        invoice: "N°",
        student: "Student",
        date: "Date",
        amount: "Amount",
        status: "Status",
        type: "Type",
        send: "Send",
        client: "Customer"
      },
      settings: {
        account: "Account number",
        bankName: "Bank name",
        bankAddress: "Address",
        bankUser: "Bank holder",
        notes: "Notes",
        personalInfo: "Personnal information",
        paymentInfo: "Payment information",
        brandingInfo: "Branding information",
        addressInfo: "Address information",
        logo: "Save your branding information which will be displayed on your invoices",
        uploadLogo: "Select an image file",
        logoHint: "(png;jpg;jpeg) | max. 5 Mo",
        companyName: "Company name",
        address: "Address",
        city: "City",
        street: "Street",
        streetNumber: "Street Number",
        zipCode: "Zip Code",
        country: "Country",
        phone: "Phone",
        email: "Email",
        vatNumber: "VAT Number",
        iban:  "IBAN",
        bic: "BIC",
        preferencesInfo: "Preferences",
        dueDatePreference: "Due Date Preference",
        validateDatePreference: "Validate Date Preference",
        displayStudentCount: "Display number of students on invoice",
        otherPreferences: "Other preferences",
        dueDateHint: "Due date preference",
        invoice_setting_description: "Customize your invoice settings",
        updateSuccess: "Settings updated successfully",
        preference1: "Preference 1",
        preference2: "Preference 2",
        preference3: "Preference 3",
        preference4: "Preference 4",
        addPaymentMethod: "Add a payment method",
        registeredPaymentMethods: "Others payment methods",
        currencyCodePreference: "Currency",
        paymentMethods: {
          cash: "Cash",
          bankTransfer: "Bank Transfer",
          creditCard: "Credit Card",
          paypal: "Paypal",
          stripe: "Credit Card (Stripe)",
          stripeSettingNow: "Stripe Setting Now",
          venmo: "Venmo ID",
          venmoQRCode: "Venmo QR Code",
          QRCode: "QR Code",
          eTransfer: "eTransfer",
          noAvailableMethods: "No available payment methods, please add one to continue",
          paypal_description: "Paypal description",
          stripe_description: "Stripe description",
          bankTransfer_description: "Bank Transfer description",
          creditCard_description: "Credit Card description",
          selectPaymentMethod: "Select a payment method",
          paymentMethodAdded: "Payment method added",
          stripeDescription: "Set up your Stripe connected account to allow your students to pay their bills online by credit card",
          stripeSettingNotCompleted: "Stripe setting not completed",
          changeStripeConfiguration: "Change my informations",
        },
        dueDate: {
          immediate: "Immediate",
          days7: "7 days",
          days14: "14 days",
          days30: "30 days",
          days45: "45 days",
          days60: "60 days",
        },
        validateDate: {
          immediate: "When lesson is completed",
          days1: "1 day before",
          days2: "2 days before",
          days3: "3 days before",
          days4: "4 days before",
          days5: "5 days before",
          days6: "6 days before",
          days7: "7 days before",
          days8: "8 days before",
          days9: "9 days before",
          days10: "10 days before",
          days11: "11 days before",
          days12: "12 days before",
          days13: "13 days before",
          days14: "14 days before",
        },
        tabs: {
          personal: "Personal",
          payment: "Payment",
          logo: "Logo",
          taxes: "Taxes",
          preferences: "Preferences",
        }
      },
      buttons: {
        create: "Create invoice",
        update: "Update invoice",
      },
      actions: {
        title:"",
        view: "View",
        download: "Download",
      },
      recurring: {
        title: "Recurring Invoices",
        description: "Manage your recurring invoices",
        fetchErrorTitle: "Error fetching recurring invoices",
        fetchErrorDescription: "An error occurred while fetching recurring invoices. Please try again later.",
        stopSuccessTitle: "Recurring invoice stopped",
        stopSuccessDescription: "The recurring invoice has been successfully stopped.",
        stopErrorTitle: "Error stopping recurring invoice",
        stopErrorDescription: "An error occurred while stopping the recurring invoice. Please try again later.",
        date: "Next invoice date",
        nextDate: "Next invoice date",
        customer: "Customer",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
        active: "Active",
        stopped: "Stopped",
        stop: "Stop",
        invoiceActions: "Actions",
        stopRecurrence: "Delete recurrence",
        noInvoices: "No recurring invoices found",
      }
    },
    
    settings: {
      title: "Settings",
      subtitle: "Manage your account settings and preferences",
      cardTitle: "Settings Dashboard",
      tabs: {
        students: "Students",
        teachers: "Teachers",
        categories: "Categories",
        locations: "Locations",
        invoices: "Invoices",
        taxes: "Taxes",
        shop: "Shop",
      },
      accountSettings: "Account Settings",
      profileInformation: "Profile Information",
      updatePassword: "Update Password",
      generalSettings: "General Settings",
      language: "Language",
      theme: "Theme",
      notifications: "Notifications",
      emailNotifications: "Email Notifications",
      pushNotifications: "Push Notifications",
      privacy: "Privacy",
      dataSharing: "Data Sharing Preferences",
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      logout: "Logout"
    },
    
    dashboard: {
      welcome: "Welcome",
      totalRevenue: "Total Revenue",
      lessonsScheduled: "Lessons Scheduled",
      studentsEnrolled: "Students Enrolled",
      recentActivities: "Recent Activities",
      viewAll: "View All"
    },
    
    navbar: {
      dashboard: "Dashboard",
      agenda: "Schedule",
      students: "Students",
      settings: "Settings",
      logout: "Logout"
    },
    
    auth: {
      login: "Log in",
      register: "Register",
      email: "Email address",
      password: "Password",
      name: "Name",
      loginTitle: "Welcome back!",
      loginSubtitle: "Log in to access your account.",
      registerTitle: "Create your account",
      registerSubtitle: "Sign up to start using our application.",
      loggedIn: "Logged in",
      loggedOut: "Logged out",
      profile: "Profile"
    },
    
    students: {
      all: "All",
      schoolStudents: "School",
      coachStudents: "Coach",
      noStudentAddedYet: "No students added yet",
      notAllowed: "🚫 Coach student",
      notAllowedForAll: "🚫 School student",
      myStudents: "My students",
      noStudentsAssociated: "No students associated with this family",
      familyMembers: "Family members",
      familyDetails: "Family details",
      perPage: "Results per page",
      contactStudent: "Send message",
      sendMessageTo: "Send message to {{studentName}}",
      startByAddingFirstStudent: "Start by adding your first student",
      noMatchingStudentFound: "No matching students found",
      coachStudentsDesc: "This student was created by the teacher",
      cochStudentDeleted: "This student has been deleted",
      invitationSent: "Invitation sent",
      search: "Search a student",
      studentList: "Student List",
      addStudent: "Add Student",
      passwordLinkSent: "Password reset link sent to student's email",
      addStudentTofamily: "Add Student to Family",
      addSelectedStudents: "Add Selected Students",
      confirmDeleteFamily: "Are you sure you want to delete this family and dissociate all its students?",
      add: "Add",
      editStudent: "Edit Student",
      studentDetails: "Student Details",
      name: "Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      notes: "Notes",
      street: "Street",
      streetNumber: "Street Number",
      zipCode: "Zip Code",
      noEmailForInvite: "This student doesn't have an email address, you can't send them an invitation to create an account",
      place: "City",
      notesPlaceholder: "Any important information about the student",
      addStudentTitle: "Add a New Student",
      addStudentDesc: "Fill out the form below to add a new student.",
      editStudentTitle: "Edit Student Details",
      editStudentDesc: "Modify the student details below.",
      selectStudents: "Select Students",
      billingAddress: "Address Information",
      invoiceSettings: "Invoice settings",
      selectSection: "Select section",
      splitInvoicesBetweenParents: "Split invoices between both parents",
      splitInvoicesBetweenParentsHelp: "Each invoice for this student will be divided in two, one for each parent. Parent contact details are required.",
      invoiceSplitNoticeTitle: "This invoice will be split into two",
      invoiceSplitNoticeDescription: "For split invoices, a 0.01 € adjustment was applied to the first invoice to balance the total. Two invoices will be created, one for each parent.",
      parentInfoRequiredForSplit: "Parent information must be filled for both parents to enable invoice splitting.",
      invoiceSplitParentInfoRequiredTitle: "Parent details required",
      invoiceSplitParentInfoRequiredDescription: "Complete both parents' name and email so invoices can be split correctly.",
      splitCreatedTitle: "{{count}} invoices created",
      splitCreatedSubtitle: "Billing has been split between the parents. What would you like to do now?",
      splitCreatedBillAnother: "Bill another student",
      splitCreatedBillAnotherHelp: "Back to the billing list",
      splitCreatedInvoicesTitle: "Created invoices",
      splitCreatedInvoice: "Invoice {{index}}",
      splitCreatedRecipient: "Recipient",
      splitCreatedStudent: "Student",
      splitCreatedPeriod: "Period",
      splitCreatedDate: "Date",
      splitCreatedTotal: "Total",
      splitCreatedManage: "Manage invoice",
      splitCreatedLoadError: "Unable to load this invoice's details.",
      splitCreatedPending: "Pending",
      selected: "Selected",
      found: "Found",
      founds: "Found",
      student: "Student",
      students: "Students",
      families: "Families",
      firstName: "First Name",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter the student's last name",
      firstNamePlaceholder: "Enter the student's first name",
      emailPlaceholder: "Enter the student's email address",
      phonePlaceholder: "Enter the student's phone number",
      mobile: "Mobile",
      mobilePlaceholder: "Enter the student's mobile number",
      parentInfo: "Parent Information",
      motherName: "Mother's Name",
      fatherName: "Father's Name",
      motherEmail: "Mother's Email",
      motherEmailPlaceholder: "Enter the mother's email address",
      motherPhone: "Mother's Phone",
      motherPhonePlaceholder: "Enter the mother's phone number",
      fatherEmail: "Father's Email",
      fatherEmailPlaceholder: "Enter the father's email address",
      fatherPhone: "Father's Phone",
      fatherPhonePlaceholder: "Enter the father's phone number",
      edit: "Edit Student",
      loading_students: "Loading students",
      search_students: "Search",
      search_families: "Search",
      add_student: "Add New",
      optional: "Optional",
      studentAdded: "Student Added",
      addedToStudentsList: "Student added to the list",
      noAccount: "No Account",
      registered: "Registered",
      sendInvite: "Send Invite",
      inviteToCreateAccount: "Invite to create an account",
      note: "Note",
      noFamilies: "No Families",
      dissociateStudent: "Dissociate Student from Family",
      createFamily: "Create Family",
      createNewFamily: "Create a new family",
      family_name: "Family Name",
      emailFamily: "Family Email",
      addFamily: "Add Family",
      confirmDelete: "Confirm Delete",
      confirmDeleteDesc: "Are you sure you want to delete this {{count}} selected students ?",
      confirmDeleteStudent: "Are you sure you want to delete",
      sendIdentifier: "Resend informations",
      personalInfo: "Personal info",
      studentInvitationDesc: "Your student has received an invitation to join your school. By clicking the link in the email they just received, they can create an account and be automatically associated with your school.",
      studentInvitationDesc2: "Your student can also join your school by entering the code below from their existing student account in their profile under the \"Join\" section.",
      resendStudentAccountInformation: "Your student already has an account with the username",
      resendStudentAccountInformation2: "By resending the login information to your student, they will receive an email containing their username and a link to reset their password if needed.",
      import: {
        title: "Import Students",
        description: "Import students from a CSV file",
        file: "CSV File",
        import: "Import",
        cancel: "Cancel",
        success: "Students imported successfully",
        error: "Error importing students",
        no_file: "No file selected",
        selectedFile: "Selected File",
        invalid_file: "Invalid file format",
        empty_file: "File is empty",
      },
      duplicate: {
          title: "Detected Student Duplicates",
          description: "We have detected {{duplicate}} duplicate(s) between your personal students and those of the school. What would you like to do for each duplicate?",
          detectMode: "Duplicate detected by",
          coachStudent: "Your student",
          schoolStudent: "School student",
          doNothing: "Do nothing",
          merge: "Keep my Student",
          inviteAndMerge: "Invite & Keep",
          skip: "Do nothing",
          mergeInProgress: "Merging in progress...",
          btnDetectDuplicate: "Duplicates",
          selectStudentToMerge: "Select a student from the school to merge",
          confirmMerge: "Confirm merge",
          areYouSurToMerge: "Are you sure you want to merge",
          mergeExplication: "You keep your student and put aside the school's student",
          studentAlreadyHaveAccount: "This student already has an account in your coach space",
          schoolMustInviteHim: "The school must invite them to view their invoices and lessons",
          studentleadyHaveAccountInSchool: "This student already has an account in the school's space",
          youMustInviteHim: "You must invite him to join your space",
          neitherHaveAccount: "Neither student has an account",
      },
      msgStudentDeletedTitle: "Student Removed",
      msgConfirmDeletedStudent: "{{firstname}} {{lastname}} has been removed from your students list.",
      msgStudentAddedTitle: "Student Added",
      msgStudentAdded: "{{firstname}} {{lastname}} has been added to your students list.",
    },

    teachers: {
      title: "Teachers",
      teacher: "Teacher",
      teachers: "Teachers",
      selected: "Selected",
      selecteds: "Selected",
      searchPlaceholder: "Search",
      search: "Search a teacher",
      addTeacher: "Add Teacher",
      addTeacherDescription: "Add a new teacher to the system.",
      editTeacher: "Edit Teacher",
      editTeacherDescription: "Edit the details of the teacher.",
      deleteTeacherConfirmTitle: "Delete Teacher",
      deleteTeacherConfirmDescription: "Are you sure you want to delete this teacher?",
      canViewTeacherInvoice: "The teacher can see the teacher invoiced lessons and event of other teachers",
      name: "Name",
      email: "Email",
      status: "Status",
      active: "Active",
      invited: "Invited",
      noSearchResults: "No teachers found matching your search.",
      customizeTeacherColor: "Customize the display color of this teacher's events",
      noTeachers: "No teachers available.",
      firstName: "First Name",
      lastName: "Last Name",
      firstNamePlaceholder: "Enter first name",
      lastNamePlaceholder: "Enter last name",
      emailPlaceholder: "Enter email",
      sendInvite: "Send Invite",
      noAccount: "No Account",
      invitationAt: "Invitation sent at",
      registered: "Registered",
      customizePrices: "Customize Prices",
      customPricesFor: "Customize Prices for",
      useCustomPrices: "Use Custom Prices",
      priceFix: "Fixed Price",
      moreThan20: "More than 20",
      inviteTeacherTitle: "Invite a teacher",
      inviteTeacherDescription: "Send an invitation to allow this teacher to create an account and join your space. By creating an account using your invitation link, they will be able to view their assigned courses and invoices.",
      emailRequired: "An email is required to send an invitation.",
      canViewOthers: "The teacher can see the school invoiced lessons and events of other teachers",
      customSettings: "Custom settings",
      associatedTeachers: "Can view the schedule of the selected teachers"
    },

    payment: {
      processing: "Processing payment...",
      invoice: "Invoice",
      goto_account: "Go to Account",
      back_to_pricing: "Back to Pricing",
      payment_details: "Payment Details",
      complete_payment: "Pay Now",
      try_again: "Try Again",
      payment_successful: "Payment Successful",
      success_description: "Thank you for your payment. Your subscription has been activated.",
      payment_failed: "Payment Failed",
      failed_description: "We're sorry, but your payment could not be processed. Please try again later.",
      title: "Invoice Payment",
      subtitle: "Pay your coach {{coach}} by credit card",
      card_details: "Card Details",
      subscription: "Subscription Premium Plan",
      total: "Total",
      email: "Email",
      cardholder: "Cardholder Name",
      billed_monthly: "Billed Monthly",
      billed_annually: "Billed Annually",
      annual_discount: "Annual Discount",
      order_summary: "Order Summary",
      pay: "Pay",
      card_number: "Card Number", 
      expiry: "Expiry Date",
      cvv: "CVV", 
      secure_encryption: "Your payment information is securely encrypted.",
      infos: "Click on Pay Now, you agree to the Terms and Conditions", 
    },

    subscription: {
      please_wait: "Please wait...",
      processing: "Processing payment...",
      goto_account: "Go to Account",
      back_to_pricing: "Back to Pricing",
      payment_details: "Payment Details",
      complete_payment: "Pay Now",
      try_again: "Try Again",
      payment_successful: "Payment Successful",
      success_description: "Thank you for your payment. Your subscription has been activated.",
      payment_failed: "Payment Failed",
      failed_description: "We're sorry, but your payment could not be processed. Please try again later.",
      title: "Payment Information",
      subtitle: "Enter your payment details below",
      card_details: "Card Details",
      expiry_date: "Expiry Date",
      cvc: "Code",
      subscription: "Subscription Premium Plan",
      subscription_details: "Subscription Details",
      total: "Total",
      email: "Email",
      cardholder: "Cardholder Name",
      billed_monthly: "Billed Monthly",
      billed_annually: "Billed Annually",
      annual_discount: "Annual Discount",
      order_summary: "Order Summary",
      pay: "Pay",
      card_number: "Card Number", 
      expiry: "Expiry Date",
      cvv: "CVV", 
      secure_encryption: "Your payment information is securely encrypted.",
      infos: "Your subscription will be automatically renewed every month. You can cancel your subscription at any time in the My Subscription section of your profile. Click on Pay Now, you agree to the Terms and Conditions", 
      error_title: "Error",
      retry: "Retry",
      success_title: "Success",
      go_to_account: "Go to Account",
      promo_code: "Promo Code",
      apply: "Apply",
      promo_code_applied: "Promo code applied",
      invalid_promo_code: "Invalid promo code",
      subscription_successful: "Subscription Successful",
      premiumAccess: "Premium Access",
      addYourCouponCode: "Add your discount code",
      discountWillBeApply: "The discount will be automatically applied to your next invoice upon validation",
      enterCode: "Enter code",
      importantInfo: "Important Information",
      addCoupon: "Add coupon",
      discount_applied: "Discount applied",
      total_after_discount: "Total after discount",
      discount_once: "Discount (once)",
      discount_forever: "Discount (forever)",
      discount_repeating: "Discount ({{months}} months)",
    },
    
    invoiceDetail: {
      date: "Date",
      subtitle: "Invoice Details",
      download: "Download PDF",
      send: "Send Invoice",
      invoice: "Invoice",
      from: "From",
      to: "To",
      invoiceDate: "Invoice Date",
      dueDate: "Due Date",
      description: "Description",
      quantity: "Duration",
      unitPrice: "Unit Price",
      total: "Total",
      subtotal: "Subtotal",
      tax: "Tax",
      paymentMethod: "Payment Method",
      paymentInstructions: "Payment Instructions",
      thankyou: "Thank you for your business!",
      vatNumber: "VAT Number",
      pdfDownloaded: "PDF downloaded",
      selectRecipients: "Select Recipients",
      sendToRecipients: "Send invoice",
      sendInvoice: "Send Invoice",
      noEmailsSelected: "No Email Selected",
      pleaseSelectEmails: "Please Select Emails",
      onlinePayment: "Online payment by bank card (via your account)",
      paypalPayment: "Payment by Paypal",
      eTransferPayment: "Payment by e-transfer",
      cashPayment: "Payment by Cash",
      bankName: "Bank Name",
      bankAccount: "Bank Account",
      banIBAN: "Bank IBAN",
      bankSwift: "Bank SWIFT",
      bankUser: "Bank holder",
      bankAddress: "Address",
      discount: "Discount",
      delete: "Delete",
      sentSuccess: "Invoice sent successfully",
      sentSuccessDescription: "The invoice has been sent to the selected recipients.",
      noEmailsAvailable: "No email addresses available for this student",
      createSenderEmail: "Save as the student's default address",
      cannotDelete: "You cannot delete this invoice",
      cannotDeleteMessage: "The invoice you are trying to delete is marked as paid. You can only delete invoices that have not yet been paid.",
      pay: "Pay now",
      extra: "Extra",
      edit: "Edit",
      shopPending: "It may take a few seconds to verify your payment method...",
      refresh: "Refresh Status",
      discountScopeLessons: "Discount on lessons",
      discountScopeEvents: "Discount on events",
    },

    validation: {
      required: "Required",
    },

    categories: {
      create_new: "Create New Category",
      loading_categories: "Loading categories...",
      search_categories: "Search",
      edit: "Edit category",
      name: "Name",
      color: "Color on schedule",
      paymentType: "Payment Type",
      hourly_rate: "Hourly Rate",
      fixed_price: "Fixed Price",
      price_per_student: "Price of the event per Student",
      per_student: "Per Student",
      student: "Student",
      students: "Students",
      hourly: "Hourly",
      more_than: "More than",
      confirmDelete: "Confirm Delete",
      confirmDeleteCategory: "Are you sure you want to delete the category",
      hourly_rate_explication: "Set up a price per students, per hour, that depends on the number of students during the lesson.",
      fixed_price_explication: "Set up a price per students, per hour, that is the same regardless of the number of students during the lesson.",
      hourlyRates: "Hourly Rates",
      fixedPrices: "Fixed Prices",
      noHourlyCategories: "No hourly rate categories found",
      noFixedCategories: "No fixed price categories found",
      additional_price: "Additional Price",
      tabStudents: "Student prices",
      tabTeachers: "Teacher price",
      price_per_teacher: "Price per Teacher",
      updated: "Category updated",
      hasBeenUpdated: "has been updated",
      teacherPriceExplanation: "This is the price that the coach is invoicing the school for this category.",
      StudentPriceExplanation: "This is the price that the student will be invoiced for this category.",
    },

    locations: {
      locations: "Locations",
      loading_locations: "Loading locations",
      search_locations: "Search",
      edit: "Edit location",
      name: "Location name",
      school_location: "School location",
      add_location: "Add",
      create_new: "Add New Location",
      confirmDelete: "Confirm Delete",
      confirmDeleteLocation: "Are you sure you want to delete the location"
    },

    taxes: {
      title: "Taxes",
      loading_taxes: "Loading taxes",
      search_taxes: "Search",
      add: "Add",
      update: "Update",
      create_new: "Create New",
      edit: "Edit tax",
      confirmDelete: "Confirm Delete",
      confirmDeleteTaxe: "Are you sure you want to delete the tax",
      tax_name: "Taxe Name",
      percentage: "Percentage",
      tax_number: "Tax Number/ID",
      amount: "Amount",
      optional: "Optional"
    },

    sessions: {
      sessions: "Sessions",
      sessions_subtitle: "Manage devices where you're currently logged in",
      current: "Current",
      last_active: "Last active",
      logout: "Logout",
      logoutAll: "Logout all devices",
    },

    reports: {
      invoiceReport: "Invoice Report",
      filterButton: "Apply Filter",
      totalRevenue: "Total Revenue",
      totalPaid: "Total Paid",
      totalPending: "Total Pending",
      totalInvoices: "Total Invoices",
      overview: "Overview",
      monthlyBreakdown: "Monthly Breakdown",
      topStudents: "Top Students",
      revenueOverview: "Revenue Overview",
      revenueDescription: "Revenue breakdown by month",
      monthlyDescription: "Detailed monthly invoice data",
      topStudentsDescription: "Students with highest spending",
      paymentMethods: "Payment Methods",
      paymentMethodsDescription: "Revenue by payment method",
      month: "Month",
      revenue: "Revenue",
      paid: "Paid",
      pending: "Pending",
      invoiceCount: "Invoices",
      total: "Total",
      studentName: "Student Name",
      totalSpent: "Total Spent",
      downloadReport: "Download Report",
      saveReport: "Save Report",
      saving: "Saving...",
      saveSuccess: "Report Saved",
      saveSuccessDescription: "The report has been saved successfully",
      saveError: "Error Saving Report",
      saveErrorDescription: "There was an error saving the report",
      downloadStarted: "Download Started",
      downloadStartedDescription: "Your report is being generated",
      exportReport: "Export Report",
      exportReportDescription: "Download your report",
      exportNow: "Export Now",
      exportComplete: "Export Complete",
      exportCompleteDesc: "Your report is being generated",
      expenses: "Extra charges",
      beforeTax: "Before Tax",
      includingTax: "Including tax",
      taxes: "Taxes",
      card: "Card",
      cash: "Cash",
      bankTransfer: "Bank Transfer",
      PayPal: "PayPal",
      Stripe: "Credit Card (Stripe)",
      Venmo: "Venmo",
      ETransfer: "E-Transfer",
      months: {
        January: "January",
        February: "February",
        March: "March",
        April: "April",
        May: "May",
        June: "June",
        July: "July",
        August: "August",
        September: "September",
        October: "October",
        November: "November",
        December: "December"
      },
      paymentMethod: "Payment Methods",
      totalAmount: "Total"
    },

    verify: {
      verifyAccount: "Verify Your Account",
      verifyAccountDesc: "Please enter the verification code that was sent to you",
      enterCode: "Enter the 6-digit code sent to your email",
      placeHolder: "Enter verification code",
      bntValidatingAccount: "Validating",
      btnSendingCode: "Sending",
      resendCode: "Resend code",
      bntVerifyAccount: "Verify Account",
      doNotReceiveCode: "Didn't receive the code?",
      invalidCode: "Invalid validation code. Please try again",
      accountValidated: "Account validated",
      accountValidatedDesc: "Your account has been successfully validated.",
      validationFailed: "Validation Failed",
      codeSent: "Code sent",
      codeSentDesc: "A new verification code has been sent to your email",
      resendFailed: "Resend failed",
      resendFailedDesc: "Failed to resend verification code"
    },

    date: {
      selectStartDate: "Select Start Date",
      selectEndDate: "Select End Date",
      selected: "Selected",
    },

    maintenance: {
      title: "Page under maintenance",
      description: "This page is temporarily unavailable. We are working to get it back online as soon as possible",
      backToHome: "Back To Home"
    },


    invitations: {
      title: "Invite to Join your School",
      description: "Send an invitation to a coach already registered on ThePoppyApp to join your school. Your coach will receive an email with instructions to accept the invitation by entering the code from their account in profile section, which they will receive by email.",
      coachEmail: "Recipient email address",
      studentEmail: "Student Email",
      sendInvitation: "Send Invitation",
      sentInvitations: "Sent Invitations",
      sentInvitationDesc: "List of your recent invitations sent to join your school",
      noInvitationsSentYet: "No invitations sent yet",
      yourSchoolJoinCode: "Your school's join code",
      yourSchoolJoinCodeDesc: "Share this code with your coaches to allow them to join your school from their account by entering this code in the 'Join' section in their profile settings.",
      sent: "Sent",
      joinSchool: "Join A New School",
      enterInvitationCode: "Enter the invitation code you received by email to join your new school.",
      invitationCode: "Invitation Code",
      joinSchoolBtn: "Join School",
      managerCoachInvitation: "Manage coach invitations for your school",
      joinSchoolWithCode: "Join a school with your invitation code",
      pleaseEnterCode: "Please enter an invitation code",
      invalidCode: "Invalid code",
      alreadyRegistered: "You are already registered in this school",
      placeholder: "Enter invitation code",

      toJoinDesc: "Join a sports school and start your adventure now!",
      connectedSchool: "Connected School",
      connectedSchoolDesc: "You are currently connected to a school",
      connectedTeacherSchool: "You are a teacher at this school",
      connectedStatusTeacherSchool: "Connected Teacher",
      syncAgenda: "Synchronized Agenda",
      syncAgendaDesc: "Synchronize your schedule with the school in real time",
      studentAccess: "Student Access",
      studentAccessDesc: "Manage the school's students in your system",
      condifdentiality: "Confidentiality",
      condifdentialityDesc: "Your settings and categories remain private",
      leaveInformation: "To join another school, you must first dissociate from the current school",
      leaveSchool: "Leave School",
      isLeaveSchool: "Leave the School?",
      asLeaveSchoolDesc: "Are you sure you want to dissociate from",
      consequences: "Consequences",
      consequence1: "Loss of access to the school's students",
      consequence2: "Desynchronization of the shared agenda",
      consequence3: "Return to independent coach status",
      deconnectSchool: "Disconnection",
      connexion: "Connection in progress",
      congratulations: "Congratulations",
      welcomeToSchool: "Welcome to the school",
      yourNewSchool: "your new school",
      successfullJoined: "You have successfully joined the team. Your coaching adventure begins now",
      goToAgenda: "View Schedule",
      goToSettings: "Manage Duplicates",
      goToStudents: "View Students",
      goToInvoices: "View Invoices",
      noBackPossible: "This action is irreversible",

      leaveInformations: "You are about to leave",
      sharingSchedule: "Shared schedule",
      youLooseSharingSchedule: "You will lose access to the shared schedule with your teachers",
      studentList: "Student list",
      youLooseStudentList: "You will no longer appear in the school's student list",
      forRejoinSchool: "To rejoin this school, you will need to request a new invitation from your teacher",
      confirmAndLeave: "Confirm and leave the school",

      inviteStudent: "Invite Student",
      inviteStudentDesc: "Send an invitation to a student to join your school",
      sentInvitationStudentDesc: "View your sent student invitations"
    },

    referral: {
      title: "Referrals",
      description: "Share your invite link! Get your next month free for every coach who joins ThePoppyApp and subscribes using your link.",
      coachEmail: "Coach Email",
      sendInvitation: "My referrals",
      sentInvitations: "Bonus & Referrals",
      sentInvitationDesc: "List of your bonuses obtained",
      noInvitationsSentYet: "No referrals yet",
      sent: "Joined",
      joinSchool: "Join School",
      enterInvitationCode: "Enter your invitation code to join a school",
      invitationCode: "Invitation Code",
      joinSchoolBtn: "Join School",
      managerCoachInvitation: "Manage coach invitations for your school",
      joinSchoolWithCode: "Join a school with your invitation code",
      pleaseEnterCode: "Please enter an invitation code",
      invalidCode: "Invalid code",
      linkCopied: "Link copied",
      linkCopiedSuccessfully: "Link copied  successfully",
      yourInviteLink: "Your Invite Link",
      copyLink: "Copy now",
      notSubscribed: "Not subscribed",
      subscribed: "Subscribed",
      freeMonth: "1 Free Month",
    },

    notifications: {
      title: "Notifications",
      noNotifications: "No notifications yet",
      notificationPreferences: "Notification Preferences",
      notificationPreferencesSubtitle: "Manage how and when we contact you",
      emailNotifications: "Email Notifications",
      pushNotifications: "Push Notifications",
      notificationsSettingsSaved: "Notification preferences saved",
      notificationsSettingsSavedDesc: "Your notification settings have been updated",
      savePreferences: "Save Preferences",
      list: [
        { 
          id: "email_new_bookings", 
          label: "New bookings", 
          description: "Receive an email when a new lesson is booked" 
        },
        { 
          id: "email_lesson_reminders", 
          label: "Lesson reminders", 
          description: "Get reminded about upcoming lessons" 
        },
        { 
          id: "email_schedule_changes", 
          label: "Schedule changes", 
          description: "Be notified when a lesson is rescheduled or canceled" 
        },
        { 
          id: "email_student_off", 
          label: "Student absences", 
          description: "Receive a notification when a student cancels or is absent" 
        },
        { 
          id: "email_teacher_off", 
          label: "Teacher absences", 
          description: "Receive a notification when a coach cancels a lesson" 
        },
        { 
          id: "email_marketing_updates", 
          label: "Marketing and updates", 
          description: "News about ThePoppyApp features and updates" 
        },
      ],
       pushList: [
        { 
          id: "push_new_bookings", 
          label: "New bookings", 
          description: "Receive a notification when a new lesson is booked" 
        },
        { 
          id: "push_lesson_reminders", 
          label: "Lesson reminders", 
          description: "Get reminded 1 hour before upcoming lessons" 
        },
        { 
          id: "push_schedule_changes", 
          label: "Schedule changes", 
          description: "Be notified when a lesson is rescheduled or canceled" 
        },
        { 
          id: "push_student_off", 
          label: "Student absences", 
          description: "Receive a push notification when a student cancels" 
        },
        { 
          id: "push_teacher_off", 
          label: "Teacher absences", 
          description: "Receive a push notification when a coach cancels" 
        },
      ],
    },

    pagination: {
      previous: "Previous",
      next: "Next"
    },

    
  "legal": {
    "title": "Legal Information",
    "subtitle": "Important legal documents and policies",
    "tabs": {
      "terms": "Terms of Service",
      "privacy": "Privacy Policy",
      "cookies": "Cookie Policy"
    },
    "terms": {
      "title": "Terms of Service",
      "lastUpdated": "Last updated: June 1, 2025",
      "sections": {
        "introduction": {
          "title": "1. Introduction",
          "content": "Welcome to ThePoppyApp (\"we,\" \"our,\" or \"us\"). By accessing or using our website, mobile applications, or any of our services, you agree to be bound by these Terms of Service."
        },
        "accountRegistration": {
          "title": "2. Account Registration",
          "content": "To use certain features of our services, you may need to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete."
        },
        "subscriptionAndPayments": {
          "title": "3. Subscription and Payments",
          "content": "ThePoppyApp offers subscription-based services. By subscribing to our services, you agree to pay the applicable fees as they become due. Subscriptions automatically renew until canceled."
        },
        "userContent": {
          "title": "4. User Content",
          "content": "You retain ownership of any content you submit, post, or display on or through our services (\"User Content\"). By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free license to use, copy, modify, and display your User Content in connection with the services."
        },
        "prohibitedActivities": {
          "title": "5. Prohibited Activities",
          "content": "You agree not to engage in any of the following prohibited activities: (i) copying, distributing, or disclosing any part of our services; (ii) using any automated system to access our services; (iii) attempting to interfere with the proper working of our services."
        },
        "termination": {
          "title": "6. Termination",
          "content": "We may terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we determine violates these Terms of Service or is harmful to other users, us, or third parties, or for any other reason."
        },
        "disclaimerOfWarranties": {
          "title": "7. Disclaimer of Warranties",
          "content": "Our services are provided \"as is\" and \"as available\" without warranties of any kind, either express or implied."
        },
        "limitationOfLiability": {
          "title": "8. Limitation of Liability",
          "content": "In no event will we be liable for any indirect, special, incidental, consequential, exemplary, or punitive damages."
        },
        "changesToTerms": {
          "title": "9. Changes to Terms",
          "content": "We may modify these Terms of Service at any time. Your continued use of our services after any such changes constitutes your acceptance of the new terms."
        },
        "governingLaw": {
          "title": "10. Governing Law",
          "content": "These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions."
        }
      }
    },
    "privacy": {
      "title": "Privacy Policy",
      "lastUpdated": "Last updated: June 1, 2025",
      "sections": {
        "informationWeCollect": {
          "title": "1. Information We Collect",
          "content": "We collect information that you provide directly to us, such as when you create an account, update your profile, use interactive features, make a purchase, or contact us. This information may include your name, email address, phone number, and payment information."
        },
        "howWeUseYourInformation": {
          "title": "2. How We Use Your Information",
          "content": "We use the information we collect to provide, maintain, and improve our services, to process transactions, to send you technical notices and support messages, to communicate with you about products, services, and events, and to respond to your comments and questions."
        },
        "sharingOfInformation": {
          "title": "3. Sharing of Information",
          "content": "We may share your information with service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, and hosting services. We may also share information if required by law or in connection with a sale, merger, or acquisition."
        },
        "security": {
          "title": "4. Security",
          "content": "We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction."
        },
        "yourChoices": {
          "title": "5. Your Choices",
          "content": "You can access and update certain information about your account by logging into your account settings. You can also opt out of receiving promotional emails from us by following the instructions in those emails."
        },
        "cookies": {
          "title": "6. Cookies",
          "content": "We use cookies and similar technologies to collect information about your browsing activities and to distinguish you from other users of our services. You can set your browser to refuse all or some browser cookies, but this may affect your ability to use our services."
        },
        "internationalDataTransfers": {
          "title": "7. International Data Transfers",
          "content": "We may transfer your personal information to countries other than the one in which you live. We rely on legally-provided mechanisms to lawfully transfer data across borders."
        },
        "childrensPrivacy": {
          "title": "8. Children's Privacy",
          "content": "Our services are not directed to children under 13, and we do not knowingly collect personal information from children under 13."
        },
        "changesToThisPrivacyPolicy": {
          "title": "9. Changes to This Privacy Policy",
          "content": "We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy."
        },
        "contactUs": {
          "title": "10. Contact Us",
          "content": "If you have any questions about this Privacy Policy, please contact us at contact@thepoppyapp.com."
        }
      }
    },
    "cookies": {
      "title": "Cookie Policy",
      "lastUpdated": "Last updated: June 1, 2025",
      "sections": {
        "whatAreCookies": {
          "title": "1. What Are Cookies",
          "content": "Cookies are small pieces of text sent to your web browser by a website you visit. A cookie file is stored in your web browser and allows our services or a third-party to recognize you and make your next visit easier and the service more useful to you."
        },
        "howWeUseCookies": {
          "title": "2. How We Use Cookies",
          "content": "We use cookies for the following purposes: Authentication: To identify you when you log in to our services, Security: To help protect your account from unauthorized access, Preferences: To remember information about how you prefer the service to behave and look, Analytics: To help us understand how you use our services, which features are most popular, and where we can make improvements."
        },
        "typesOfCookiesWeUse": {
          "title": "3. Types of Cookies We Use",
          "content": "We use both session cookies and persistent cookies. Session cookies are temporary and are deleted when you close your browser. Persistent cookies remain on your device until they expire or you delete them."
        },
        "thirdPartyCookies": {
          "title": "4. Third-Party Cookies",
          "content": "In addition to our own cookies, we may also use various third-party cookies to report usage statistics, deliver advertisements, and so on."
        },
        "managingCookies": {
          "title": "5. Managing Cookies",
          "content": "Most web browsers allow you to control cookies through their settings preferences. However, limiting the ability of websites to set cookies may affect your overall user experience. If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser."
        },
        "changesToThisCookiePolicy": {
          "title": "6. Changes to This Cookie Policy",
          "content": "We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page."
        }
      }
    }
  },

  update: {
    browser: {
      title: "Browser Update Required",
      description: "Your version of Safari is not compatible with this application.",
      detected: "Detected browser:",
      minimumVersion: "Minimum required version for Safari: 15.0",
      explanation: "To use this application, please update Safari to version 15.0 or higher, or use another browser such as Chrome, Firefox, or Edge.",
      instruction: "On macOS, update your operating system to get the latest versions of Safari. On iOS, update to the latest version of iOS.",
      goHome: "Go back to home",
      learnMore: "How to update Safari"
    }
  },


    
    footer: {
      professional_platform: "The all-in-one platform for schools and independent teachers",
      change_language: "Change language",
      product: "Product",
      resources: "Resources",
      company: "Company",
      integrations: "Integrations",
      customers: "Customers",
      community: "Community",
      careers: "Careers",
      terms: "Terms of Service",
      privacy: "Privacy Policy"
    },

    shop: {
    title: "Shop",
    subtitle: "Manage your shop items",
    createProduct: "Create New Product",
    editProduct: "Edit Product",
    createProductDescription: "Create coupon books or tickets for your students to purchase",
    editProductDescription: "Edit an existing product",
    yourProducts: "Your Products",
    yourProductsDescription: "View and manage your ticket books and coupons",
    productTitle: "Title",
    titlePlaceholder: "Enter product title",
    description: "Description",
    descriptionPlaceholder: "Enter product description",
    quantity: "Quantity",
    selectQuantity: "Select quantity",
    tickets: "tickets",
    ticket: "ticket",
    price: "Price",
    pricePerTicket: "Price per ticket",
    priceHelp: "This is the price for a single ticket. Total price will be calculated automatically.",
    totalPrice: "Total price",
    addProduct: "Add Product",
    noProducts: "No products yet",
    productCreated: "Product created",
    productCreatedDescription: "Your product has been created successfully",
    productUpdated: "Product updated",
    productUpdatedDescription: "Your product has been updated successfully",
    productDeleted: "Product deleted",
    productDeletedDescription: "Your product has been deleted successfully",
    confirmDelete: "Delete product",
    confirmDeleteDescription: "Are you sure you want to delete this product? This action cannot be undone.",
    fillAllFields: "Please fill all required fields",
    invalidPrice: "Please enter a valid price",
    buyNow: "Buy Now",
    shopNow: "Shop Now",
    addToCart: "Add to Cart",
    viewShop: "View Shop",
    Subtotal: "Subtotal",
    yourCoachHasNoProductsYet: "Your coach has no products yet",
    stripeConfigured: "Set up your connected account",
    manageStripeAccount: "Manage your connected account",
    shopNotEnable: "Set up your connected account to enable your shop",
    showPayments: "Show payments"
  },

  contact: {
    title: "Contact Us",
    subtitle: "We're here to help.",
    description: "Send us a message and we'll get back to you as soon as possible.",
    name: "Name",
    email: "Email",
    subject: "Subject",
    howWeCanHelp: "How can we help?",
    message: "Message",
    messagePlaceholder: "Your message here...",
    sendMessage: "Send Message",
    successTitle: "Message Sent",
    successMessage: "Thank you for reaching out! We have received your message and will get back to you shortly.",
    errorTitle: "Error",
    errorMessage: "There was an error sending your message. Please try again later.",
    helpInfo: "Need Help?",
    contactDetails: "Contact Details",
    form: {
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send",
      thankYou: "Thank you!",
      success: "Your message has been sent successfully",
      error: "Please fill all fields correctly"
    },
    info: {
      title: "Get in Touch",
      phone: "Phone",
      email: "contact @ thepoppyapp.com",
      help: "Ask a question or request support",
      ready: "Ready to transform your coaching business? Try our platform today"
    },
    choiceSubject: {
      selectTopic: "Select a topic",
      enterTopic: "Enter a topic",
      accountIssues: "Account Issues",
      billingPayments: "Billing & Payments",
      featureRequests: "Feature Requests",
      technicalSUpport: "Technical Support",
      other: "Other",
    },
    closeContact: "Close this conversation",
    closeContactDesc: "This will permanently delete this conversation with ThePoppyApp support",
    contactClosed: "This conversation is closed",
    selectAConversation: "Select a conversation",
    selectDesc: "You have an ongoing conversation. Please select it from the list or close it before starting a new one"

  },
  bot:{
    typeYourMessage: "Ask your question",
    send: "Send"
  },
  wizard: {
    settings: "Click on Settings to manage your categories and other settings",
    categories: "Create and organize your service categories. Add at least one category to continue", 
    categoriesTab: "This is where you can create and manage your service categories. Categories help you organize your services and set different prices for each type of service you offer.",
    students: "Add your first student to start managing your coaching business more efficiently",
    studentsTab: "This is where you can add and manage your students. Adding students allows you to keep track of their information, schedule lessons, and manage payments more effectively.",
    lessons: "Create your first lesson and start using the platform to manage your coaching business more efficiently",
    lessonsTab: "This is where you can create and manage your lessons. You can schedule lessons, assign them to categories, and link them to your students for easy management.",
    teachersTab: "This is where you can add and manage your teachers. Adding teachers allows you to assign them to lessons and manage their schedules more effectively.",
    addTeacher: "Add your first teacher to start managing your coaching business more efficiently",
    addCategory: "Add your first category",
    addStudent: "Add your first student",
    addLesson: "Add your first lesson",
    confirmStopTitle: "Stop the tour?",
    confirmStopDesc: "Are you sure you want to stop the tour? You can always access it later from the help section in your profile settings.",
    confirmStopAction: "Stop the tour",
    createLesson: "Use this button to create a new lesson. You can set the date, time, category, and assign students to the lesson.",
    welcome: {
      title: "Welcome to ThePoppyApp!",
      subtitle: "Let's get you set up in just a few steps",
      step1: "Step 1: Create your first category",
      step2: "Step 2: Create your first student",
      step3: "Step 3: Create your first lesson",
      step1Desc:"First, let's create your first category. Categories help you organize your services and set different prices for each type of service you offer.",
      step2Desc: "In the next step, you will create your first student",
      step3Desc: "Finally, you will be able to create your first lesson and start using the platform to manage your coaching business more efficiently",
      skip: "Skip the tour",
      start: "Start the tour"
    },
    congrats: {
      title: "Congratulations!",
      subtitle: "You're all set up and ready to go",
      description: "You have completed the initial setup and created your first category, student, and lesson. You're now ready to start using ThePoppyApp to manage your coaching business more efficiently. If you need any help, feel free to reach out to our support team.",
      goToDashboard: "Go to Dashboard",
      createLesson: "Create your first lesson",
      later: "Later"
    }
  }
},
  
};

export default en;
